// Arabic (MSA - Modern Standard Arabic) translations
export const ar = {
  // Navigation
  nav: {
    about: 'من نحن',
    packages: 'الباقات',
    technologies: 'التقنيات',
    services: 'الخدمات',
    process: 'العملية',
    contact: 'اتصل بنا',
    cta: 'تواصل معنا'
  },
  
  // Hero Section
  hero: {
    title1: 'استشارات الذكاء الاصطناعي',
    title2: 'للعصر الجديد',
    subtitle: 'أتمتة الأعمال والتحول الرقمي',
    description: 'نبتكر أنظمة أعمال ذكية باستخدام الذكاء الاصطناعي. من الاستراتيجية إلى التنفيذ الكامل.',
    ctaPrimary: 'اختر باقة',
    ctaSecondary: 'استشارة'
  },
  
  // About Section
  about: {
    title: 'شريكك في التحول الرقمي',
    paragraph1: 'العالم يتسارع. الشركات التي تطبق الذكاء الاصطناعي اليوم تصبح قادة الغد.',
    paragraph2: 'من الاستراتيجية إلى التنفيذ الكامل - نبتكر أنظمة أعمال ذكية بنتائج قابلة للقياس.',
    whyChoose: 'لماذا نحن',
    benefits: [
      {
        title: 'دورة كاملة - من الاستراتيجية إلى التنفيذ',
        description: 'نحن لا نقدم الاستشارات فقط - نبتكر حلولاً عملية. نحلل ونصمم وننفذ وندعم حتى تحقيق النتائج.'
      },
      {
        title: 'أرقام تثبت النتائج',
        description: 'نقيس كل شيء: الوقت، الكفاءة، الربح. مؤشرات الأداء الرئيسية والعائد على الاستثمار وتحليلات الأعمال تظهر كيف يجعل الذكاء الاصطناعي عملك أسرع وأدق وأكثر ربحية.'
      },
      {
        title: 'الذكاء الاصطناعي - أداة وليس المستقبل',
        description: 'نطبق تقنيات تحقق الأرباح للأعمال اليوم - من أتمتة المهام إلى التحليلات المبنية على البيانات.'
      },
      {
        title: 'خبرة دولية ومرونة',
        description: 'مقرنا في إستونيا، نعمل مع عملاء حول العالم. نكيف الحلول لأسواق ومقاييس مختلفة.'
      },
      {
        title: 'شراكة وليس تعاقد',
        description: 'لسنا مجرد مستشارين - نندمج مع فريقك ونوصل المشروع إلى تأثير ملموس.'
      }
    ]
  },
  
  // Packages Section
  packages: {
    title: 'حلول للنمو الرقمي',
    subtitle: 'من الاستراتيجية إلى الأتمتة وتطبيق الذكاء الاصطناعي',
    popular: 'الأكثر شعبية',
    learnMore: 'معرفة المزيد',
    result: 'النتيجة:',
    items: [
      {
        name: 'INSIGHT',
        icon: '🔴',
        tagline: 'التحليل واستراتيجية النمو',
        price: '€1,500 - €2,500',
        description: 'للشركات الصغيرة والمتوسطة، والشركات الناشئة',
        features: [
          'تدقيق كامل للأعمال والعمليات',
          'تحليل المنافسين والنضج الرقمي',
          'تحليل SWOT وخريطة نقاط النمو',
          'توصيات الذكاء الاصطناعي والأتمتة',
          'استراتيجية صغيرة لمدة 3 أشهر',
          'جلسة استراتيجية (90 دقيقة)'
        ],
        result: 'فهم أين تخسر الأعمال الأموال وخطة نمو واضحة'
      },
      {
        name: 'GROWTH ENGINE',
        icon: '🔵',
        tagline: 'النمو المنهجي والأتمتة',
        price: '€4,500 - €9,000',
        description: 'الانتقال إلى النمو المنهجي والرقمنة',
        features: [
          'كل شيء من باقة INSIGHT',
          'استراتيجية لمدة 6 أشهر',
          'تطبيق أنظمة CRM / ERP',
          'روبوتات الدردشة بالذكاء الاصطناعي ومسارات تلقائية',
          'تحليلات شاملة ولوحات معلومات BI',
          'استشارات الموارد البشرية وتطبيق مؤشرات الأداء',
          'دعم لمدة 3 أشهر'
        ],
        result: 'نمو مستقر، إدارة شفافة، أتمتة العمليات'
      },
      {
        name: 'AI TRANSFORM',
        icon: '🟣',
        tagline: 'التحول الرقمي للأعمال',
        price: '€12,000 - €30,000',
        description: 'للشركات المتوسطة والكبيرة',
        features: [
          'كل شيء من باقة GROWTH ENGINE',
          'خارطة طريق رقمية وذكاء اصطناعي سنوية',
          'أتمتة شاملة للعمليات',
          'تطبيق حلول الذكاء الاصطناعي',
          'تحديث البنية التحتية لتكنولوجيا المعلومات',
          'تدريب الموظفين',
          'مشرف مشروع فردي'
        ],
        result: 'تحول كامل للذكاء الاصطناعي: نظام بيئي قابل للتطوير يعتمد على البيانات'
      },
      {
        name: 'PROJECT+',
        icon: '⚫',
        tagline: 'حلول مخصصة',
        price: 'من €5,000',
        description: 'مشاريع مخصصة متكاملة',
        features: [
          'روبوتات ومساعدين ذكاء اصطناعي',
          'أتمتة CRM/ERP',
          'إنشاء SaaS أو منصة سوق',
          'تحليلات BI والتنبؤ',
          'التحضير للاستثمارات',
          'دمج الذكاء الاصطناعي في العمليات'
        ],
        result: 'حل جاهز مكيف وفق أهدافك ومقياسك'
      }
    ]
  },
  
  // Technologies Section
  technologies: {
    title: 'التقنيات والأدوات',
    subtitle: 'حلول أتمتة متقدمة',
    items: [
      {
        title: 'الذكاء الاصطناعي',
        description: 'التعلم الآلي، معالجة اللغة الطبيعية، رؤية الكمبيوتر، التحليلات التنبؤية',
        keywords: ['ChatGPT', 'Claude', 'Gemini', 'ذكاء اصطناعي مخصص']
      },
      {
        title: 'أتمتة العمليات',
        description: 'RPA، أتمتة سير العمل، تكامل API، العمليات التجارية',
        keywords: ['Make', 'Zapier', 'n8n', 'نصوص مخصصة']
      },
      {
        title: 'أنظمة CRM و ERP',
        description: 'التطبيق والتكوين وتحسين أنظمة الإدارة',
        keywords: ['Bitrix24', 'Salesforce', 'SAP', '1C']
      },
      {
        title: 'ذكاء الأعمال والتحليلات',
        description: 'ذكاء الأعمال، لوحات المعلومات، تصور البيانات',
        keywords: ['Power BI', 'Tableau', 'Looker', 'مخصص']
      }
    ]
  },
  
  // Services Section
  services: {
    title: 'خدماتنا',
    subtitle: 'حلول شاملة لنمو الأعمال',
    items: [
      {
        title: 'استشارات الأعمال',
        description: 'التخطيط الاستراتيجي، تحسين العمليات، زيادة الأرباح'
      },
      {
        title: 'التحول الرقمي',
        description: 'رقمنة الأعمال، تطبيق التقنيات الحديثة، التوسع'
      },
      {
        title: 'الاستشارات المالية',
        description: 'التحليل المالي، تحسين التكاليف، التخطيط وإدارة المخاطر'
      },
      {
        title: 'الدعم القانوني',
        description: 'قانون الشركات، العقود، GDPR، التشريعات الدولية'
      },
      {
        title: 'استشارات الموارد البشرية',
        description: 'إدارة الموظفين، مؤشرات الأداء، تحفيز الفريق، تطوير المواهب'
      },
      {
        title: 'الأتمتة',
        description: 'أتمتة العمليات التجارية، التكاملات، تحسين الكفاءة'
      },
      {
        title: 'تطبيق الذكاء الاصطناعي والتعلم الآلي',
        description: 'الذكاء الاصطناعي للأعمال، التحليلات، التنبؤ، روبوتات الدردشة'
      }
    ]
  },
  
  // Why Us Section
  whyUs: {
    title: 'نتائج تتحدث عن نفسها',
    subtitle: 'مقاييس كفاءتنا',
    items: [
      {
        prefix: 'حتى',
        number: '92%',
        title: 'نمو الكفاءة',
        description: 'متوسط زيادة الإنتاجية بعد تطبيق حلولنا'
      },
      {
        prefix: 'حتى',
        number: '6 أشهر',
        title: 'العائد على الاستثمار',
        description: 'متوسط الإطار الزمني لعائد الاستثمار في الأتمتة والذكاء الاصطناعي'
      },
      {
        number: '24/7',
        title: 'الدعم',
        description: 'الدعم الفني والاستشارات في جميع المراحل'
      },
      {
        prefix: '> ',
        number: '50',
        title: 'مشروع',
        description: 'مشاريع ذكاء اصطناعي وأتمتة منفذة بنجاح'
      }
    ]
  },
  
  // Process Section
  process: {
    title: 'عملية العمل',
    subtitle: 'من التحليل إلى النتائج',
    items: [
      {
        number: '01',
        title: 'التحليل والتدقيق',
        description: 'تحليل عميق للأعمال والعمليات والأنظمة الحالية'
      },
      {
        number: '02',
        title: 'الاستراتيجية',
        description: 'تطوير خارطة الطريق وخطة التحول الرقمي'
      },
      {
        number: '03',
        title: 'التنفيذ',
        description: 'تنفيذ تدريجي للذكاء الاصطناعي والأتمتة وأنظمة الإدارة'
      },
      {
        number: '04',
        title: 'التدريب',
        description: 'تدريب الموظفين على العمل مع التقنيات الجديدة'
      },
      {
        number: '05',
        title: 'التحسين',
        description: 'تحسين مستمر وتوسيع الحلول'
      }
    ]
  },
  
  // Contact Section
  contact: {
    title: 'اتصل بنا',
    subtitle: 'جاهز لبدء تحول عملك؟',
    selectedPackage: 'الباقة المحددة:',
    goalQuestion: 'ما هو الهدف الرئيسي من طلبك؟',
    goals: [
      'أتمتة العمليات',
      'تطبيق الذكاء الاصطناعي',
      'تحسين الكفاءة',
      'استشارة'
    ],
    multipleChoice: 'يمكنك تحديد خيارات متعددة',
    form: {
      name: 'الاسم *',
      email: 'البريد الإلكتروني *',
      company: 'اسم الشركة *',
      companyDescription: 'وصف موجز لما تفعله شركتك *',
      message: 'رسالة إضافية (اختياري)',
      terms: 'لقد قرأت ووافقت على',
      termsLink: 'شروط الخدمة',
      and: 'و',
      privacyLink: 'سياسة الخصوصية',
      termsNote: '*. بطلب الخدمات عبر أي قناة (البريد الإلكتروني، الهاتف، إلخ)، فإنك توافق تلقائيًا على شروط خدمتنا.',
      submit: 'إرسال الرسالة',
      submitting: 'جارٍ الإرسال...',
      success: 'شكراً لك! سنتواصل معك قريباً.',
      error: 'حدث خطأ. يرجى المحاولة مرة أخرى لاحقًا.'
    }
  },
  
  // Footer
  footer: {
    description: 'استشارات الجيل القادم. الذكاء الاصطناعي والأتمتة والتحول الرقمي للأعمال.',
    company: 'Polyus Plus OÜ',
    navigation: 'التنقل',
    legal: 'المعلومات القانونية',
    links: {
      about: 'من نحن',
      packages: 'الباقات',
      services: 'الخدمات',
      contact: 'اتصل بنا',
      terms: 'شروط الخدمة',
      privacy: 'سياسة الخصوصية',
      cookie: 'سياسة ملفات تعريف الارتباط',
      cookieSettings: 'إعدادات ملفات تعريف الارتباط'
    },
    rights: 'جميع الحقوق محفوظة.',
    keywords: 'استشارات الذكاء الاصطناعي | أتمتة الأعمال | التحول الرقمي'
  },
  
  // Cookie Banner
  cookie: {
    title: '🍪 إشعار ملفات تعريف الارتباط',
    description: 'نستخدم ملفات تعريف الارتباط لتحسين تجربة التصفح والتطبيقات.',
    accept: 'قبول',
    decline: 'رفض',
    settings: 'الإعدادات',
    moreDetails: 'المزيد من التفاصيل ←',
    settingsModal: {
      title: 'إعدادات ملفات تعريف الارتباط',
      subtitle: 'اختر ملفات تعريف الارتباط المسموح بها',
      alwaysEnabled: 'مفعل دائماً',
      saveSettings: 'حفظ الإعدادات',
      acceptAll: 'قبول الكل',
      categories: {
        essential: {
          name: 'ملفات تعريف الارتباط الضرورية',
          description: 'هذه ملفات تعريف الارتباط ضرورية لعمل الموقع ولا يمكن تعطيلها.'
        },
        analytics: {
          name: 'ملفات تعريف الارتباط التحليلية',
          description: 'Google Analytics 4, Hotjar - تساعد على فهم كيفية استخدام الزوار للموقع.'
        },
        marketing: {
          name: 'ملفات تعريف الارتباط التسويقية',
          description: 'Meta Pixel, TikTok Pixel - تُستخدم للإعلانات المستهدفة.'
        },
        functional: {
          name: 'ملفات تعريف الارتباط الوظيفية',
          description: 'تحسين وظائف الموقع (حفظ اللغة والسمة وما إلى ذلك).'
        }
      }
    }
  },
  
  // Meta and SEO
  meta: {
    title: 'Polyus Plus | استشارات الذكاء الاصطناعي وأتمتة الأعمال في تالين، إستونيا',
    description: 'استشارات احترافية في الذكاء الاصطناعي، أتمتة عمليات الأعمال والتحول الرقمي. تطبيق الذكاء الاصطناعي، زيادة الكفاءة حتى 92٪، عائد استثمار شفاف. استشارات في تالين، نعمل في جميع أنحاء العالم.',
    keywords: 'استشارات الذكاء الاصطناعي، أتمتة الأعمال، التحول الرقمي، تطبيق الذكاء الاصطناعي، عمليات الأعمال، استشارات إستونيا، تالين، الذكاء الاصطناعي، KPI، ROI، كفاءة الأعمال، Google Analytics 4، Hotjar، Facebook Pixel',
    ogTitle: 'Polyus Plus | استشارات الذكاء الاصطناعي وأتمتة الأعمال',
    ogDescription: 'استشارات احترافية في الذكاء الاصطناعي، أتمتة عمليات الأعمال والتحول الرقمي. زيادة الكفاءة حتى 92٪، عائد استثمار شفاف.',
    siteName: 'Polyus Plus',
    footer: {
      company: 'عن الشركة',
      about: 'من نحن',
      packages: 'الباقات',
      services: 'الخدمات',
      contact: 'اتصل بنا',
      terms: 'شروط الخدمة',
      privacy: 'سياسة الخصوصية',
      cookie: 'سياسة ملفات تعريف الارتباط',
      cookieSettings: 'إعدادات ملفات تعريف الارتباط'
    },
    rights: 'جميع الحقوق محفوظة.'
  }
};
